import { useLocation } from "react-router-dom";

import useHub from "data/hub/useHub";

import { useFlags } from "components/FeatureFlag";

import { SCREEN_TYPE } from "../../Container";

export function useHubComponentManager({
  workflowLength,
  isViewActive,
  isViewLoading = false,
  activeScreen = SCREEN_TYPE.WORKFLOW,
}) {
  const hub = useHub();
  const location = useLocation();
  const { loadingConfig } = useFlags();

  const resolving = isViewLoading || loadingConfig;
  const useCases = Boolean(hub?.useCases?.visible);

  return {
    showButton: {
      filters: workflowLength > 0 && activeScreen !== SCREEN_TYPE.INSIGHTS,
      clearAll:
        (workflowLength > 0 || isViewActive) &&
        activeScreen !== SCREEN_TYPE.INSIGHTS,
      createOrSaveView:
        workflowLength > 0 && activeScreen !== SCREEN_TYPE.INSIGHTS,
    },
    showWidget: {
      loader: resolving,
      useCases: !resolving && useCases,
      onboardingContent:
        !resolving &&
        !useCases &&
        location?.pathname.endsWith("/welcome/education"),
    },
    showWorkspace: workflowLength > 0,
  };
}

export default useHubComponentManager;
